import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    /** 获取banner列表 **/
    GET_BANNER_LIST(data) {
        controller='Banner';
        action='GetBannerList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取banner详情 **/
    GET_BANNER_INFO(data) {
        controller='Banner';
        action='GetBannerInfo';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 新增banner **/
    ADD_BANNER(data) {
        controller='Banner';
        action='AddBanner';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 编辑banner **/
    EDIT_BANNER(data) {
        controller='Banner';
        action='EditBanner';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 删除banner **/
    DEL_BANNER(data) {
        controller='Banner';
        action='DelBanner';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 修改banner是否显示 **/
    CHANGE_BANNER_SHOW(data) {
        controller='Banner';
        action='ChangeBannerShow';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

}
